/* Translation of locales/en-US/packs.ts (generated from lib/industryPacks/catalog.ts). Same keys;
 * only the values are translated. */
export const packs = {
  "property": {
    "assetTypes": {
      "0": "Haus",
      "1": "Wohnung",
      "2": "Büro",
      "3": "Heizkessel",
      "4": "Elektroanlage",
      "5": "Brandschutzausrüstung",
      "6": "Gerät"
    },
    "sample": {
      "name": "Beispielimmobilie",
      "description": "Eine Beispielimmobilie, damit Sie eine Inspektion ausprobieren können, bevor Sie Ihre eigenen hinzufügen."
    },
    "templates": {
      "condition_inspection": {
        "name": "Zustandsinspektion der Immobilie",
        "description": "Gehen Sie durch die Immobilie und erfassen Sie ihren Zustand Raum für Raum.",
        "items": {
          "0": {
            "label": "Außenbereich und Grundstück"
          },
          "1": {
            "label": "Dach, Dachrinnen und Regenfallrohre"
          },
          "2": {
            "label": "Fenster und Außentüren"
          },
          "3": {
            "label": "Feuchtigkeit, Schimmel oder Wasserschaden",
            "description": "Antworten Sie mit Ja, wenn etwas davon vorhanden ist."
          },
          "4": {
            "label": "Heizung und Warmwasser funktionieren"
          },
          "5": {
            "label": "Innenzustand insgesamt"
          }
        }
      },
      "room_inspection": {
        "name": "Rauminspektion",
        "description": "Ein einzelner Raum, so genau erfasst, dass sich später ein Streit klären lässt.",
        "groups": {
          "0": {
            "label": "Raumzustand",
            "guidance": "Nehmen Sie Wände, Decke, Boden und Fenster auf. Zeigen Sie den Rauchmelder, falls vorhanden."
          },
          "1": {
            "label": "Installationen und Ausstattung"
          }
        },
        "items": {
          "0": {
            "label": "Wände und Decke"
          },
          "1": {
            "label": "Bodenbelag"
          },
          "2": {
            "label": "Fenster und Verglasung"
          },
          "3": {
            "label": "Rauchmelder vorhanden"
          },
          "4": {
            "label": "Steckdosen, Schalter und Beleuchtung"
          },
          "5": {
            "label": "Einbauten und Ausstattung"
          },
          "6": {
            "label": "Sauberkeit"
          }
        }
      },
      "move_in_out": {
        "name": "Einzug / Auszug",
        "description": "Das Protokoll, dem beide Seiten bei der Übergabe zustimmen.",
        "items": {
          "0": {
            "label": "Zählerstände erfasst"
          },
          "1": {
            "label": "Schlüssel übergeben und gezählt"
          },
          "2": {
            "label": "Rauch- und CO-Melder getestet"
          },
          "3": {
            "label": "Sauberkeit insgesamt"
          },
          "4": {
            "label": "Vorhandene Schäden fotografiert"
          },
          "5": {
            "label": "Geräte vorhanden und funktionsfähig"
          }
        }
      },
      "fire_safety_check": {
        "name": "Brandschutzprüfung",
        "description": "Melder, Fluchtwege und Ausrüstung. Ein Nachweis, keine rechtliche Bewertung.",
        "items": {
          "0": {
            "label": "Rauchmelder vorhanden und Signal ertönt"
          },
          "1": {
            "label": "Kohlenmonoxidmelder vorhanden und Signal ertönt"
          },
          "2": {
            "label": "Fluchtwege frei"
          },
          "3": {
            "label": "Brandschutztüren schließen vollständig"
          },
          "4": {
            "label": "Feuerlöscher innerhalb der Prüffrist"
          },
          "5": {
            "label": "Notbeleuchtung funktioniert"
          }
        }
      },
      "maintenance_walkthrough": {
        "name": "Allgemeiner Wartungsrundgang",
        "description": "Der routinemäßige Rundgang, der Probleme erkennt, solange sie klein sind.",
        "items": {
          "0": {
            "label": "Sanitärinstallation und sichtbare Lecks"
          },
          "1": {
            "label": "Zustand der Heizungsanlage"
          },
          "2": {
            "label": "Elektrik und sichtbare Leitungen"
          },
          "3": {
            "label": "Türen, Schlösser und Sicherheit"
          },
          "4": {
            "label": "Grundstück und Entwässerung"
          }
        }
      }
    },
    "maintenance": {
      "boiler_annual_service": {
        "title": "Jährliche Heizkesselwartung",
        "description": "Den Heizkessel warten und den Gassicherheitsnachweis aktuell halten."
      },
      "fire_safety_quarterly": {
        "title": "Vierteljährliche Brandschutzprüfung",
        "description": "Melder, Fluchtwege und Ausrüstung."
      }
    },
    "compliance": {
      "gas_safety": {
        "label": "Gassicherheitsnachweis"
      },
      "eicr": {
        "label": "Prüfbericht zum Zustand der Elektroinstallation (EICR)"
      },
      "fire_safety": {
        "label": "Brandschutznachweis, einschließlich Rauch- und CO-Meldern"
      }
    }
  },
  "fleet": {
    "assetTypes": {
      "0": "Pkw",
      "1": "Transporter",
      "2": "Lkw",
      "3": "Anhänger"
    },
    "sample": {
      "name": "Beispiel-Transporter",
      "description": "Ein Beispielfahrzeug, damit Sie eine tägliche Kontrolle ausprobieren können, bevor Sie Ihre eigenen hinzufügen."
    },
    "templates": {
      "daily_vehicle_check": {
        "name": "Tägliche Fahrzeugkontrolle",
        "description": "Der Rundgang, bevor das Fahrzeug losfährt.",
        "items": {
          "0": {
            "label": "Beleuchtung und Blinker"
          },
          "1": {
            "label": "Reifen und Reifendruck"
          },
          "2": {
            "label": "Bremsen fühlen sich normal an"
          },
          "3": {
            "label": "Spiegel und Scheiben"
          },
          "4": {
            "label": "Flüssigkeitsstände"
          },
          "5": {
            "label": "Warnleuchten im Armaturenbrett",
            "description": "Antworten Sie mit Ja, wenn eine davon leuchtet."
          },
          "6": {
            "label": "Ladung gesichert"
          }
        }
      },
      "vehicle_condition": {
        "name": "Fahrzeugzustand",
        "description": "Das ausführlichere Zustandsprotokoll, von der Karosserie bis zum Innenraum.",
        "groups": {
          "0": {
            "label": "Außen",
            "guidance": "Gehen Sie um das Fahrzeug herum. Zeigen Sie jede Seite, die Beleuchtung, die Scheiben und die Reifen."
          },
          "1": {
            "label": "Innenraum",
            "guidance": "Zeigen Sie die Sitze, das Armaturenbrett und den Kilometerzähler."
          },
          "2": {
            "label": "Unterlagen"
          }
        },
        "items": {
          "0": {
            "label": "Zustand der Karosserie"
          },
          "1": {
            "label": "Reifenprofiltiefe ausreichend"
          },
          "2": {
            "label": "Scheiben und Spiegel"
          },
          "3": {
            "label": "Beleuchtung intakt"
          },
          "4": {
            "label": "Zustand des Innenraums"
          },
          "5": {
            "label": "Kilometerstand"
          },
          "6": {
            "label": "Servicehistorie aktuell"
          }
        }
      },
      "damage_inspection": {
        "name": "Schadensinspektion",
        "description": "Was passiert ist, wo und wie es aussieht.",
        "items": {
          "0": {
            "label": "Schaden von allen Seiten fotografiert"
          },
          "1": {
            "label": "Fahrzeug weiterhin verkehrssicher"
          },
          "2": {
            "label": "Karosserieteile und Karosserie"
          },
          "3": {
            "label": "Scheiben und Beleuchtung intakt"
          },
          "4": {
            "label": "Dritte beteiligt"
          }
        }
      },
      "handover": {
        "name": "Fahrzeugübergabe",
        "description": "Zustand und Inhalt in dem Moment, in dem die Schlüssel übergeben werden.",
        "items": {
          "0": {
            "label": "Kilometerstand erfasst"
          },
          "1": {
            "label": "Tank- oder Ladestand erfasst"
          },
          "2": {
            "label": "Schlüssel und Papiere übergeben"
          },
          "3": {
            "label": "Vorhandene Schäden erfasst"
          },
          "4": {
            "label": "Sauberkeit"
          }
        }
      },
      "tyres": {
        "name": "Reifenprüfung",
        "description": "Profil, Druck und Zustand, Rad für Rad.",
        "items": {
          "0": {
            "label": "Vorne links"
          },
          "1": {
            "label": "Vorne rechts"
          },
          "2": {
            "label": "Hinten links"
          },
          "3": {
            "label": "Hinten rechts"
          },
          "4": {
            "label": "Reserverad oder Pannenset vorhanden"
          }
        }
      },
      "service_check": {
        "name": "Servicekontrolle",
        "description": "Was die Werkstatt geprüft und festgestellt hat.",
        "items": {
          "0": {
            "label": "Kilometerstand erfasst"
          },
          "1": {
            "label": "Öl und Filter gewechselt"
          },
          "2": {
            "label": "Bremsen geprüft"
          },
          "3": {
            "label": "Fahrwerk und Lenkung"
          },
          "4": {
            "label": "Fehlercodes ausgelesen und gelöscht"
          }
        }
      }
    },
    "maintenance": {
      "service_whichever_first": {
        "title": "Service: 12 Monate oder 10.000 Meilen",
        "description": "Je nachdem, was zuerst eintritt, gerechnet ab dem letzten abgeschlossenen Service."
      },
      "service_calendar": {
        "title": "Jährlicher Service",
        "description": "Alle 12 Monate ab dem letzten abgeschlossenen Service."
      },
      "service_mileage": {
        "title": "Service alle 10.000 Meilen",
        "description": "Nur nach Strecke, gerechnet ab dem Zählerstand beim letzten Service."
      }
    },
    "compliance": {
      "roadworthy": {
        "label": "Prüfung der Verkehrssicherheit, etwa die jährliche Fahrzeugprüfung (MOT)"
      },
      "insurance": {
        "label": "Kfz-Versicherung"
      }
    }
  },
  "equipment": {
    "assetTypes": {
      "0": "Maschine",
      "1": "Werkzeug",
      "2": "Hebezeug",
      "3": "Gabelstapler",
      "4": "Kompressor"
    },
    "sample": {
      "name": "Beispielmaschine",
      "description": "Eine Beispielmaschine, damit Sie eine Kontrolle vor Gebrauch ausprobieren können, bevor Sie Ihre eigenen hinzufügen."
    },
    "templates": {
      "pre_use_check": {
        "name": "Kontrolle vor Gebrauch",
        "description": "Die Kontrolle, bevor die Bedienperson mit der Arbeit beginnt.",
        "items": {
          "0": {
            "label": "Schutz- und Sicherheitseinrichtungen vorhanden"
          },
          "1": {
            "label": "Not-Halt funktioniert"
          },
          "2": {
            "label": "Keine sichtbaren Schäden oder Lecks"
          },
          "3": {
            "label": "Bedienelemente und Anzeigen funktionieren"
          },
          "4": {
            "label": "Betriebsstunden erfasst"
          }
        }
      },
      "condition_inspection": {
        "name": "Zustandsinspektion",
        "description": "Wie gut sich die Maschine hält.",
        "groups": {
          "0": {
            "label": "Kennzeichnung",
            "guidance": "Zeigen Sie das Typenschild und das Anlagenetikett."
          },
          "1": {
            "label": "Äußerer Zustand",
            "guidance": "Nehmen Sie Vorderseite, Seiten und Sockel der Ausrüstung auf. Erfassen Sie auch Schutzeinrichtungen, Schläuche und Anschlüsse."
          },
          "2": {
            "label": "Betriebsdaten",
            "guidance": "Zeigen Sie den Betriebsstundenzähler."
          },
          "3": {
            "label": "Funktionsprüfung"
          }
        },
        "items": {
          "0": {
            "label": "Seriennummer"
          },
          "1": {
            "label": "Allgemeiner Zustand"
          },
          "2": {
            "label": "Sichtbare Leckagen"
          },
          "3": {
            "label": "Schutzeinrichtungen vorhanden und sicher befestigt"
          },
          "4": {
            "label": "Elektrische Kabel und Steckverbinder"
          },
          "5": {
            "label": "Hydraulik und Pneumatik"
          },
          "6": {
            "label": "Schilder und Kennzeichnungen lesbar"
          },
          "7": {
            "label": "Betriebsstunden"
          },
          "8": {
            "label": "Verschleiß an beweglichen Teilen"
          },
          "9": {
            "label": "Startet und läuft einwandfrei"
          },
          "10": {
            "label": "Keine ungewöhnlichen Geräusche oder Vibrationen"
          }
        }
      },
      "maintenance_inspection": {
        "name": "Wartungsinspektion",
        "description": "Der geplante Serviceeinsatz und was er ergeben hat.",
        "items": {
          "0": {
            "label": "Betriebsstunden oder Zyklen erfasst"
          },
          "1": {
            "label": "Schmierung durchgeführt"
          },
          "2": {
            "label": "Filter und Verbrauchsmaterial ersetzt"
          },
          "3": {
            "label": "Sicherheitseinrichtungen erneut geprüft"
          },
          "4": {
            "label": "Wieder in Betrieb genommen"
          }
        }
      },
      "calibration_evidence": {
        "name": "Prüfung des Kalibriernachweises",
        "description": "Ob die erfasste Kalibrierung aktuell und rückverfolgbar ist.",
        "items": {
          "0": {
            "label": "Kalibrierzertifikat liegt vor"
          },
          "1": {
            "label": "Kalibrierung noch gültig"
          },
          "2": {
            "label": "Kalibrieretikett am Gerät"
          },
          "3": {
            "label": "Referenznormal rückverfolgbar"
          }
        }
      }
    },
    "maintenance": {
      "service_operating_hours": {
        "title": "Service alle 500 Betriebsstunden",
        "description": "Gerechnet ab dem Betriebsstundenstand beim letzten abgeschlossenen Service.",
        "programmeTitle": "Betriebsstunden-Programm"
      },
      "service_operating_hours_major": {
        "title": "Großer Service alle 1.000 Betriebsstunden",
        "description": "Der gründlichere Service, gemessen am selben Betriebsstundenzähler."
      },
      "service_cycles": {
        "title": "Überholung alle 2.000 Zyklen",
        "description": "Gerechnet ab dem Zyklenstand bei der letzten abgeschlossenen Überholung."
      }
    },
    "compliance": {
      "lifting": {
        "label": "Gründliche Prüfung von Hebezeugen"
      },
      "electrical": {
        "label": "Nachweis der elektrischen Sicherheit, etwa ein Prüfprotokoll für ortsveränderliche Geräte (PAT)"
      }
    }
  },
  "facilities": {
    "assetTypes": {
      "0": "Gebäude",
      "1": "HLK-Anlage",
      "2": "Pumpe",
      "3": "Stromerzeuger",
      "4": "Brandschutzanlage",
      "5": "Stromverteilung"
    },
    "sample": {
      "name": "Beispielgebäude",
      "description": "Ein Beispielgebäude, damit Sie eine Inspektion ausprobieren können, bevor Sie Ihre eigenen hinzufügen."
    },
    "templates": {
      "planned_maintenance": {
        "name": "Planmäßige Wartung",
        "description": "Der geplante Einsatz an einer technischen Anlage.",
        "items": {
          "0": {
            "label": "Betriebsstunden erfasst"
          },
          "1": {
            "label": "Filter und Riemen"
          },
          "2": {
            "label": "Lecks, Geräusche oder Vibrationen"
          },
          "3": {
            "label": "Regelung und Sollwerte korrekt"
          },
          "4": {
            "label": "Trenn- und Sicherheitseinrichtungen geprüft"
          }
        }
      },
      "condition_inspection": {
        "name": "Zustandsinspektion",
        "description": "Wie gut sich das Gebäude und seine technischen Anlagen halten.",
        "items": {
          "0": {
            "label": "Bausubstanz"
          },
          "1": {
            "label": "Dach und Entwässerung"
          },
          "2": {
            "label": "Mechanische Anlagen"
          },
          "3": {
            "label": "Stromverteilung"
          },
          "4": {
            "label": "Gemeinschaftsflächen"
          }
        }
      },
      "safety_inspection": {
        "name": "Sicherheitsinspektion",
        "description": "Was stimmen muss, bevor sich jemand im Gebäude aufhält.",
        "items": {
          "0": {
            "label": "Brandmelderzentrale ohne Meldung"
          },
          "1": {
            "label": "Fluchtwege und Notausgänge frei"
          },
          "2": {
            "label": "Notbeleuchtung funktioniert"
          },
          "3": {
            "label": "Feuerlöscher innerhalb der Prüffrist und an ihrem Platz"
          },
          "4": {
            "label": "Beschilderung vorhanden und lesbar"
          }
        }
      },
      "plant_room_check": {
        "name": "Technikraum-Kontrolle",
        "description": "Der routinemäßige Rundgang durch den Technikraum.",
        "items": {
          "0": {
            "label": "Technikraum gesichert und frei"
          },
          "1": {
            "label": "Keine Lecks oder stehendes Wasser"
          },
          "2": {
            "label": "Drücke und Temperaturen im Sollbereich"
          },
          "3": {
            "label": "Alarme und Anzeigen normal"
          },
          "4": {
            "label": "Belüftung frei"
          }
        }
      },
      "energy_walkround": {
        "name": "Energie- und Umwelt-Rundgang",
        "description": "Ein Rundgang durch ein Gebäude auf der Suche nach verschwendeter Energie und Wasser, und ob die Zähler abgelesen wurden.",
        "items": {
          "0": {
            "label": "Zähler diesen Monat abgelesen"
          },
          "1": {
            "label": "Licht in leeren Bereichen aus"
          },
          "2": {
            "label": "Heizung und Kühlung auf die vereinbarten Temperaturen eingestellt"
          },
          "3": {
            "label": "Heizung und Kühlung laufen nicht gleichzeitig"
          },
          "4": {
            "label": "Türen und Fenster geschlossen, wo geheizt oder gekühlt wird"
          },
          "5": {
            "label": "Keine tropfenden Wasserhähne oder laufenden Toiletten"
          },
          "6": {
            "label": "Geräte außerhalb der Arbeitszeit ausgeschaltet"
          },
          "7": {
            "label": "Energieausweis ausgehängt, wo vorgeschrieben"
          }
        }
      },
      "fgas_leak_check": {
        "name": "F-Gas-Dichtheitsprüfung",
        "description": "Die regelmäßige Dichtheitsprüfung einer Anlage mit fluorierten Kältemitteln durch einen zertifizierten Techniker.",
        "items": {
          "0": {
            "label": "Techniker F-Gas-zertifiziert"
          },
          "1": {
            "label": "Verbindungen, Ventile und Dichtungen auf Lecks geprüft"
          },
          "2": {
            "label": "Leckage-Erkennung funktioniert (falls vorhanden)"
          },
          "3": {
            "label": "Keine Ölspuren an Verbindungen"
          },
          "4": {
            "label": "Kältemittel nachgefüllt (kg am Asset erfassen)"
          },
          "5": {
            "label": "Leck gefunden"
          },
          "6": {
            "label": "Typenschild zeigt Kältemittelart und Füllmenge"
          }
        }
      }
    },
    "maintenance": {
      "ppm_quarterly": {
        "title": "Vierteljährliche planmäßige Wartung",
        "description": "Alle 3 Monate ab dem letzten abgeschlossenen Einsatz."
      },
      "generator_hours": {
        "title": "Stromerzeuger-Service alle 250 Betriebsstunden",
        "description": "Gerechnet ab dem Betriebsstundenstand beim letzten abgeschlossenen Service."
      }
    },
    "compliance": {
      "energy_performance": {
        "label": "Energieausweis (EPC)"
      },
      "water_hygiene": {
        "label": "Nachweis der Wasserhygiene, etwa eine Legionellen-Gefährdungsbeurteilung"
      },
      "fire_safety": {
        "label": "Brandschutznachweis"
      },
      "lifting": {
        "label": "Gründliche Prüfung von Hebezeugen"
      },
      "electrical": {
        "label": "Prüfbericht zum Zustand der Elektroinstallation (EICR)"
      }
    }
  }
};
